/**
 * Compares two prices with decimal precision.
 * Use this instead of tolerance-based comparison (e.g. Math.abs(a - b) < 0.01)
 * to correctly distinguish prices like 2060.19 vs 2060.20.
 *
 * @param price1 - First price (number or string)
 * @param price2 - Second price (number or string)
 * @param decimals - Decimal places for comparison (default 5 for prediction prices)
 */
export function isPriceEqual(
  price1: number | string,
  price2: number | string,
  decimals = 5
): boolean {
  const num1 = typeof price1 === 'string' ? parseFloat(price1) : price1;
  const num2 = typeof price2 === 'string' ? parseFloat(price2) : price2;

  if (Number.isNaN(num1) || Number.isNaN(num2)) return false;

  const factor = Math.pow(10, decimals);
  return Math.round(num1 * factor) === Math.round(num2 * factor);
}
